import React, { createContext, FC, useContext } from 'react';

import {
    type PackArchitectureContextValue,
    usePackArchitectureProvider,
} from './usePackArchitectureProvider';

const noop = () => undefined;

const DEFAULT_CONTEXT: PackArchitectureContextValue = {
    title: '',
    tooltip: '',
    tableTooltip: '',
    xAxis: '',
    setXAxis: noop,
    yAxis: '',
    setYAxis: noop,
    bubbleRepresents: '',
    setBubbleRepresents: noop,
    bubbleSize: '',
    setBubbleSize: noop,
    showHeatMap: false,
    setShowHeatMap: noop,
    heatMapToggle: undefined,
    tableKpiOptionItems: [],
    selectedKpis: [],
    toggleTableKpi: noop,
    tableSearchInput: '',
    setTableSearchInput: noop,
    submitTableSearch: noop,
    tableSearchKeyword: '',
    xAxisOptionGroups: [],
    yAxisOptionGroups: [],
    bubbleRepresentsOptionGroups: [],
    bubbleSizeOptionGroups: [],
    xAxisGroupByControlsMeta: undefined,
    xAxisKpiControlsMeta: undefined,
    xAxisKpiDataRange: undefined,
    setXAxisDimensionConfig: noop,
    setXAxisKpiConfig: noop,
    rows: [],
    tableRows: [],
    bubbleLegend: null,
    isChartLoading: false,
    isChartPaginatedLoading: false,
    isTablePaginatedLoading: false,
    isChartTableRefetching: false,
    isChartTableLoaderRefetching: false,
    isChartPanelLoading: false,
    isChartError: false,
    hasChartData: false,
    chartError: null,
    fetchNextPricePackArchitecturePage: async () => null,
    fetchNextTablePage: async () => undefined,
    hasMorePages: false,
    tableHasMorePages: false,
    totalCount: 0,
    effectiveRowCount: 0,
    chartRequest: null,
    selection: null,
    activeSegmentKey: null,
    selectedColumnKey: null,
    selectedBubbleKey: null,
    toggleSegmentSelection: noop,
    selectSegment: noop,
    selectBubble: noop,
    selectTableCell: noop,
    clearSelection: noop,
    showNoFilterSelection: false,
};

const PackArchitectureDataContext = createContext<PackArchitectureContextValue>(DEFAULT_CONTEXT);

type Props = {
    children: React.ReactNode;
};

const PackArchitectureContext: FC<Props> = ({ children }) => {
    const value = usePackArchitectureProvider();
    return <PackArchitectureDataContext.Provider value={value}>{children}</PackArchitectureDataContext.Provider>;
};

const usePackArchitectureContext = () => useContext(PackArchitectureDataContext);

const PackArchitectureContextWrapper: FC<Props> = ({ children }) => (
    <PackArchitectureContext>{children}</PackArchitectureContext>
);

export { PackArchitectureContext, PackArchitectureContextWrapper, usePackArchitectureContext };
